import React from 'react';
import BaseApi from '../../api/BaseApi.js';
import ScreenCaption from '../screen-caption.js';
import details from '../../img/details.svg';
import add from '../../img/add.svg';


export default class RefsScreen extends React.Component {
    constructor(props) {
        super(props);

        const args = props.args === undefined ? {} : props.args

        var refrecid = null
        if (props.args.refrecid) {
            refrecid = props.args.refrecid
        }    

        this.state = {
              refrecid: refrecid,  
              args: args, 
              refs: []  
        }
    }  
    
    async componentDidMount() {
        BaseApi.get('/refs', {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: {refrecid: this.state.refrecid}, withCredentials: true})
        .then(res => {
            this.setState({refs: res.data})
        })    
        .catch(error=>console.log(error))
    }

    openRef(id) {
        this.props.navigate("ref", {caller: "refs", callargs: this.state.args, ref: id, refrecid: this.state.refrecid})
    }

    renderRef(ref) {
        const getFullUrl = (url) => {
            if (url.startsWith('http://') || url.startsWith('https://')) {
                return url;
            }
            return `https://${url}`;  // по умолчанию HTTPS
        };
        return (
            <tr>
                <td>
                    <a href={getFullUrl(ref.ref)} target="_blank">{ref.name}</a>
                </td>
                <td onClick={()=>this.openRef(ref.id)}> 
                    <i class="bi bi-pencil-square"></i>
                </td>
            </tr>
        )      
    }

    render() {
        return (
            <div class="container">
            <ScreenCaption goback={this.props.goback} args={this.state.args} caption={"Ссылки"}/>
            <div className="card shadow-sm">
                <div className="card-body p-0">
                    <div className="table-responsive">
                        <table className="table table-sm table-hover mb-0 align-middle">
                            <thead className="table-primary">
                                <tr>
                                    <th >Ссылка</th>
                                    <th onClick={()=>{this.openRef("")}}>
                                        <i class="bi bi-plus-circle"></i>
                                    </th>     
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.refs.map((value, index) => this.renderRef(value))}
                            </tbody>
                        </table> 
                    </div>
                </div> 
           
                
            </div>
            
        </div> 
        )
    }
}    


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/refs-screen.js